import Rest from './BaseRest'
import DjangoRest from './DjanoBaseRest'

const resource = 'accounts'

export default {
  SearchAccounts (keywords) {
    return Rest.get(`${resource}?search=${keywords}`)
  },
  FetchAccounts () {
    return Rest.get(`${resource}`)
  },
  FetchAccount (id) {
    return Rest.get(`${resource}/${id}`)
  },
  StoreAccount (member) {
    return Rest.post(`${resource}`, member)
  },
  UpdateAccount (account) {
    return Rest.put(`${resource}/${account.id}`, account)
  },
  DestroyAccount (id) {
    return Rest.delete(`${resource}/${id}`)
  },
  StoreAccountV2 (member) {
    return DjangoRest.post(`${resource}/`, member)
  },
  FetchAccountV2 (id) {
    return DjangoRest.get(`${resource}/${id}`)
  },
  UpdateAccountV2 (accountId, payload) {
    return DjangoRest.post(`${resource}/${accountId}/update/`, payload)
  },
}
